import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.css'
import VueUeditorWrap from 'vue-ueditor-wrap'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.component('vue-ueditor-wrap', VueUeditorWrap)

router.beforeEach((to, from, next) => {
    if (sessionStorage.getItem('uKey')) {
        next()
    }
    else {
        if (to.name !== 'login') {
            next({path: 'login'})
        }
        else {
            next()
        }
    }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
